var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25C6.61406 5.25 2.25 9.61406 2.25 15V19.875C2.25 20.4984 1.74844 21 1.125 21C0.501562 21 0 20.4984 0 19.875V15C0 8.37188 5.37188 3 12 3C18.6281 3 24 8.37188 24 15V19.875C24 20.4984 23.4984 21 22.875 21C22.2516 21 21.75 20.4984 21.75 19.875V15C21.75 9.61406 17.3859 5.25 12 5.25Z",
    fill: "#F28520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15C5.09532 15 3.75 16.3453 3.75 18V21C3.75 22.6546 5.09532 24 6.75 24H7.5C8.32968 24 9 23.3296 9 22.5V16.5C9 15.6703 8.32968 15 7.5 15H6.75Z",
    fill: "#EA1763"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 18C20.25 16.3453 18.9047 15 17.25 15H16.5C15.6703 15 15 15.6703 15 16.5V22.5C15 23.3296 15.6703 24 16.5 24H17.25C18.9047 24 20.25 22.6546 20.25 21V18Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.596f86fb8d8d4c3446ca5c1f7cb52d04.svg";
export { ForwardRef as ReactComponent };